import { Channels } from "@bikdotai/bik-component-library";
import { isProd } from "../../config";

// The library template of the Pre-sales agent (Journey sales assistant). A store's
// copy carries it as source_meta.source_agent_id. Each environment's library has
// its own copy.
export const PRE_SALES_AGENT_LIBRARY_ID = isProd
  ? "agent_mw1wjqqk_b4ga3u"
  : "agent_mv9fhe7g_nmu4rj";

export const PRE_SALES_AGENT_NAME = "Journey sales assistant";

// The channels the Pre-sales agent runs on: WhatsApp only for now.
export const PRE_SALES_AGENT_CHANNELS: string[] = [Channels.WHATSAPP];

// A quick reply set to the Pre-sales agent at template creation
// (qrbPayload[text].isPreSalesAgent). Its buttonKey gets the prefix, so the
// node's own config says which button it is.
export const ASK_AI_BUTTON_KEY_PREFIX = "ask_ai-";

// The backend runs an attached agent under its host's node id plus this suffix
// (N5 -> N5-agent), and that id comes back in links and analytics.
export const AGENT_NODE_SUFFIX = "-agent";

// The mini builder's "Where it runs" box for the Pre-sales agent.
export const PRE_SALES_AGENT_WHERE_IT_RUNS = [
  "When user replies to marketing templates",
  "Inbound DMs with a pre-sales intent",
];

// The backend's maximum: plain replies within two days of the send wake the agent.
export const FREE_REPLY_WINDOW_SECONDS = 2 * 24 * 60 * 60;
